import a from "../../loadable/loadable.mjs";
const r = a({
  loader: () => import(
    /* webpackChunkName: 'luma-card-image' */
    "./Luma3dCardImage.mjs"
  )
});
export {
  r as default
};
